import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from '../Common/Button';

const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Failed to log out:', err);
    }
  };

  return (
    <header className="bg-white shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-8">
            <Link to="/dashboard" className="text-2xl font-bold text-blue-600">
              EHS Staffing Modeler
            </Link>
            
            {currentUser && (
              <div className="hidden md:flex space-x-6">
                <Link
                  to="/dashboard"
                  className="text-gray-700 hover:text-blue-600 font-medium"
                >
                  Dashboard
                </Link>
                <Link
                  to="/products"
                  className="text-gray-700 hover:text-blue-600 font-medium"
                >
                  Activities
                </Link>
                <Link
                  to="/results"
                  className="text-gray-700 hover:text-blue-600 font-medium"
                >
                  Results
                </Link>
                <Link
                  to="/scenarios"
                  className="text-gray-700 hover:text-blue-600 font-medium"
                >
                  Scenarios
                </Link>
                <Link
                  to="/teams"
                  className="text-gray-700 hover:text-blue-600 font-medium flex items-center"
                >
                  👥 Teams
                </Link>
                <Link
                  to="/help"
                  className="text-gray-700 hover:text-blue-600 font-medium flex items-center"
                >
                  📚 Help
                </Link>
              </div>
            )}
          </div>

          <div className="flex items-center space-x-4">
            {currentUser ? (
              <>
                <span className="text-sm text-gray-600 hidden sm:block">
                  {currentUser.email}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button variant="primary" size="sm">
                  Sign In
                </Button>
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
